module.exports = __webpack_public_path__ + "img/cns_pc16.93965c23.png";